interface StaticImageProps {
    src: string;
    title?: string;
}

export const StaticImage: React.FC<StaticImageProps> = ({ src, title, ...props }) => (
    <img {...props} src={src} alt={title || 'Image Tile'} className='m-auto object-contain h-full' />
);
